import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

const common = css`
  font-family: 'Open Sans', sans-serif;
  cursor: pointer;
  border-radius: 20px;
  border: 1px solid var(--accent);
  background-color: var(--accent);
  color: #ffffff;
  font-size: 12px;
  font-weight: bold;
  padding: 12px 45px;
  letter-spacing: 1px;
  text-transform: uppercase;
  transition: transform 80ms ease-in;
  margin-top: 1rem;

  &:active {
    transform: scale(0.95);
  }

  &:focus {
    outline: none;
  }

  &.ghost {
    background-color: transparent;
    border-color: #ffffff;
  }
`;

export const Btn = styled.button`
  ${common}
`;

export const BtnLink = styled(Link)`
  ${common}
  text-decoration: none;
  text-align: center;
`;
